import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Product, ProductVariant } from '../../types/product';
import './ProductCard.css';

interface ProductCardProps {
  product?: Product;
  variant?: ProductVariant;
  variantCount?: number;
}

const ProductCard: React.FC<ProductCardProps> = ({ product, variant, variantCount }) => {
  const navigate = useNavigate();

  // Use variant data if provided, otherwise use product data
  const displayProduct = variant ? variant.defaultVariant : product!;
  const displayName = variant ? variant.name : product!.name;
  const displayPrice = variant ? variant.priceDisplay : (product!.price && product!.price > 0 ? `€${product!.price.toFixed(2)}` : 'Price TBA');
  const actualVariantCount = variant ? variant.variants.length : variantCount;

  const handleClick = () => {
    // Navigate to the first variant's product page
    navigate(`/product/${displayProduct.id}`);
  };

  const handleBuyNow = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    navigate(`/product/${displayProduct.id}`);
  };

  const imageSrc = displayProduct.images && displayProduct.images.length > 0
    ? displayProduct.images[0]
    : '/assets/products/placeholder.png';

  return (
    <div className="product-card" onClick={handleClick}>
      <div className="product-card-image-section">
        <img
          src={imageSrc}
          alt={displayName}
          className="product-card-image"
          onError={(e) => {
            (e.target as HTMLImageElement).src = '/assets/products/gold_trophy.png';
          }}
        />
        {actualVariantCount && actualVariantCount > 1 && (
          <div className="product-card-badge">
            {actualVariantCount} variants
          </div>
        )}
      </div>
      <div className="product-card-details">
        <div className="product-card-price">{displayPrice}</div>
        <div className="product-card-name">{displayName}</div>
        <div className="product-card-sku">SKU: {displayProduct.sku || displayProduct.productId}</div>
        <button className="product-card-buy-now" onClick={handleBuyNow}>
          View Product
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
